import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { defineMessages, useIntl } from 'react-intl';
import { General, EmailTemplates } from './EditFormSection';
import { useFormikContext } from 'formik';
import useSubscriptionExpiredRestrictions from '../../../../../hooks/useSubscriptionExpiredRestrictions';

const messages = defineMessages({
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const Edit = ({ editing, closeEditForm, account }) => {
  const { formatMessage } = useIntl();
  const { handleSubmit, isSubmitting } = useFormikContext();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <form className="p-grid" onSubmit={handleSubmit}>
      <div className="p-col-12">
        <General editing={editing} />
      </div>
      <div className="p-col-12">
        <EmailTemplates editing={editing} account={account} />
      </div>

      {editing ? (
        <div className="p-col-12">
          <Button
            label={formatMessage(messages.save)}
            type="submit"
            icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
            disabled={isSubmitting || subscriptionIsExpired}
          />

          <Button
            label={formatMessage(messages.cancel)}
            className="p-button-secondary"
            type="button"
            onClick={closeEditForm}
          />
        </div>
      ) : null}
    </form>
  );
};

Edit.propTypes = {
  editing: PropTypes.bool.isRequired,
  closeEditForm: PropTypes.func.isRequired,
  account: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Edit;
